export default {
  intro: {
    default: 'Introduza os dados da pessoa que assina o contrato.',
    gbr: 'Introduza os dados do sócio que assina o contrato.',
    gmbh: 'Introduza os dados do proprietário ou gerente que assina o contrato.',
  },
  sections: {
    home_address: 'Morada',
    home_address_help: 'Onde esta pessoa vive, não a morada do restaurante.',
  },
  form: {
    owner_first_name: {
      label: 'Primeiro nome',
      placeholder: 'Introduza o primeiro nome',
    },
    owner_last_name: {
      label: 'Apelido',
      placeholder: 'Introduza o apelido',
    },
    owner_dob: {
      label: 'Data de nascimento',
      placeholder: 'Data',
    },
    owner_phone_number: {
      label: 'Telefone',
    },
    owner_email: {
      label: 'Email',
      placeholder: 'Introduza o email',
      help: 'Este pode ser diferente do email com que inicia sessão.',
    },
    owner_id_number: {
      label: 'Número de identificação (ex.: número de segurança social nos EUA)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Voltar',
    next: 'Seguinte',
  },
};
